/*
 * @Author: xuejian3721
 * @Date: 2023-10-06 18:29:10
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-02-20 18:06:14
 */
export default [
  {
    path: '/imChat',
    name: 'imChat',
    component: () => import('@/views/im-chat/pc/index.vue')
  },
  {
    path: '/mobile/imChat',
    name: 'mobileImChat',
    component: () => import('@/views/im-chat/mobile/index.vue')
  },
  // pc静态页面
  {
    path: '/staticImChat',
    name: 'staticImChat',
    component: () => import('@/views/im-chat/pc/im-chat-static/index.vue')
  },
  // APP静态页面
  {
    path: '/mobile/staticImChat',
    name: 'mobileStaticImChat',
    component: () => import('@/views/im-chat/mobile/im-chat-static/index.vue')
  }
]
